import Vue from "vue";

import { configure } from "vee-validate";
import "./assets/preflight.scss";
import "./assets/tailwind.scss";
import "./assets/variables.scss";
import "./assets/custom.scss";
import "./assets/fixes.scss";
import Uid from "@/module/Vue/Plugins/Uid/Uid";
import i18n from "@/i18n";
import FormWrapper from "@/components/Form/FormWrapper.vue";
import {
  alpha_dash,
  alpha_num,
  email,
  max,
  max_value,
  min,
  min_value,
  numeric,
  required,
  integer,
} from "vee-validate/dist/rules";
import { customRules, installRules } from "@/module/Validation/rules/index";

Vue.use(Uid);

configure({
  // @ts-ignore
  defaultMessage: function (fieldName, values: Record<string, any>): string {
    return String(i18n.t(`validations.${values._rule_}`, values));
  },
});

installRules({
  ...{
    alpha_dash,
    alpha_num,
    email,
    max,
    max_value,
    min,
    min_value,
    numeric,
    required,
    integer,
  },
  ...customRules,
});

new Vue({
  render(h) {
    return h(FormWrapper, {
      props: {
        // @ts-ignore
        path: this.path,
        // @ts-ignore
        dataUrl: this.dataUrl,
        // @ts-ignore
        dataFormResource: this.dataFormResource,
        // @ts-ignore
        securityToken: this.securityToken,
      },
    });
  },
  i18n,
  data: function () {
    return {
      path: "",
      dataUrl: "",
      dataFormResource: null,
      securityToken: "",
    };
  },
  beforeMount: function () {
    // @ts-ignore
    this.path = this.$el.getAttribute("data-path");
    // @ts-ignore
    this.dataUrl = this.$el.getAttribute("data-data-url");
    // @ts-ignore
    this.dataFormResource = this.$el.getAttribute("data-form-resource");
    // @ts-ignore
    this.securityToken = JSON.parse(
      // @ts-ignore
      this.$el.getAttribute("data-security-token"),
    );
  },
}).$mount(".fapi-form-wrapper");

(() => {
  import("@/module/Utils/SentryLoader").then(
    ({ SentryLoader: SentryLoader }) => {
      SentryLoader.loadSentry();
    },
  );
})();
